var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 1.45312C8.5625 1.17383 8.77734 0.9375 9.07812 0.9375H12.8594C13.1387 0.9375 13.375 1.17383 13.375 1.45312V5.23438C13.375 5.53516 13.1387 5.75 12.8594 5.75C12.5586 5.75 12.3438 5.53516 12.3438 5.23438V2.69922L8.21875 6.80273C8.02539 7.01758 7.70312 7.01758 7.50977 6.80273L5.125 4.41797L1.85938 7.66211C1.66602 7.87695 1.34375 7.87695 1.15039 7.66211C0.935547 7.46875 0.935547 7.14648 1.15039 6.93164L4.75977 3.32227C4.95312 3.12891 5.27539 3.12891 5.46875 3.32227L7.875 5.72852L11.6133 1.96875H9.07812C8.77734 1.96875 8.5625 1.75391 8.5625 1.45312Z",
    fill: "#57A545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.ae57f4dbf4efea5de4e2b06f973b7627.svg";
export { ForwardRef as ReactComponent };